import { all, takeEvery, put, call } from "redux-saga/effects";
import { notification } from "antd";
import { getToken } from "../../utils/utility";
import {
  allOrganizationsStatisticsService,
  allOrganizationsStatisticsByDatesRequest,
  allOrganizationsStatisticsDailyByDatesRequest,
} from "../../services/organizationsStatisticsService";
import actions from "./actions";

export function* getAllOrganizationsStatistics() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(allOrganizationsStatisticsService, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ORGANIZATIONS_STATISTICS_SUCCESS,
        organizationsStatistics: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      notification["error"]({
        message: "Грешка",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getAllOrganizationsDailyByDatesStatistics(data) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      allOrganizationsStatisticsDailyByDatesRequest,
      token,
      data.startDate,
      data.endDate
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ORGANIZATIONS_STATISTICS_DAILY_BY_DATE_SUCCESS,
        organizationsDailyStatistics: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      notification["error"]({
        message: "Грешка",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getAllOrganizationsByDatesStatistics(data) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      allOrganizationsStatisticsByDatesRequest,
      token,
      data.startDate,
      data.endDate
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ORGANIZATIONS_STATISTICS_BY_DATE_SUCCESS,
        organizationsByDatesStatistics: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      notification["error"]({
        message: "Грешка",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(
      actions.GET_ORGANIZATIONS_STATISTICS_REQUEST,
      getAllOrganizationsStatistics
    ),
    yield takeEvery(
      actions.GET_ORGANIZATIONS_STATISTICS_BY_DATE_REQUEST,
      getAllOrganizationsByDatesStatistics
    ),
    yield takeEvery(
      actions.GET_ORGANIZATIONS_STATISTICS_DAILY_BY_DATE_REQUEST,
      getAllOrganizationsDailyByDatesStatistics
    ),
  ]);
}
